// /**
//  * Live Price Ticker
//  *
//  * Built for an infinite-scroll ticker where each price item is
//  * duplicated many times in the DOM (for a seamless CSS scroll loop).
//  * Fetches each UNIQUE api-url only ONCE per refresh cycle, then applies
//  * the result to every duplicated element sharing that URL - avoids
//  * hammering the API with redundant simultaneous requests.
//  *
//  * Supports:
//  * - Header authentication
//  * - Query parameter authentication
//  * - Nested JSON values
//  * - 24h change indicator (up/down arrow, colored by sign)
//  * - Auto refresh
//  * - Per-group loading/error state
//  * - Shopify Theme Editor section reloads
//  */

// (function () {
//   'use strict';

//   function getValueByPath(object, path) {
//     if (!object || !path) return undefined;

//     return path.split('.').reduce(function (current, key) {
//       if (current !== null && current !== undefined && Object.prototype.hasOwnProperty.call(current, key)) {
//         return current[key];
//       }
//       return undefined;
//     }, object);
//   }

//   function formatNumber(value, decimals) {
//     if (value === null || value === undefined || value === '') return null;
//     var number = Number(value);
//     if (!Number.isFinite(number)) return null;
//     return number.toFixed(decimals);
//   }

//   function getApiKey(container) {
//     var configElement = container.querySelector('[data-c4h-api-config]');
//     if (!configElement) return '';

//     try {
//       var config = JSON.parse(configElement.textContent);
//       return config.apiKey || '';
//     } catch (error) {
//       console.error('[live-ticker] Unable to read API configuration:', error);
//       return '';
//     }
//   }

//   function buildRequest(container, apiUrl) {
//     var apiKey = getApiKey(container);
//     var authMethod = container.getAttribute('data-auth-method') || 'header';

//     var options = {
//       method: 'GET',
//       cache: 'no-store',
//       headers: { Accept: 'application/json' }
//     };

//     if (apiKey && authMethod === 'query') {
//       var parameterName = container.getAttribute('data-key-param-name') || 'api_key';
//       var separator = apiUrl.indexOf('?') === -1 ? '?' : '&';
//       apiUrl += separator + encodeURIComponent(parameterName) + '=' + encodeURIComponent(apiKey);
//     }

//     if (apiKey && authMethod === 'header') {
//       var headerName = container.getAttribute('data-header-name') || 'Authorization';
//       var headerPrefix = container.getAttribute('data-header-prefix') || '';
//       options.headers[headerName] = headerPrefix + apiKey;
//     }

//     return { url: apiUrl, options: options };
//   }

//   /**
//    * Apply a successful response to every duplicated copy of one item.
//    */
//   function applyDataToGroup(elements, data) {
//     elements.forEach(function (item) {
//       var valueEl = item.querySelector('[data-rate-value]');
//       var changeEl = item.querySelector('[data-rate-change]');

//       var jsonKey = item.getAttribute('data-rate-key');
//       var decimals = parseInt(item.getAttribute('data-rate-decimals') || '2', 10);
//       var prefix = item.getAttribute('data-rate-prefix') || '';
//       var suffix = item.getAttribute('data-rate-suffix') || '';

//       var rawValue = getValueByPath(data, jsonKey);
//       var formattedValue = formatNumber(rawValue, decimals);

//       if (formattedValue !== null) {
//         if (valueEl) valueEl.textContent = prefix + formattedValue + suffix;
//         item.classList.remove('is-loading', 'is-error');
//       } else {
//         if (valueEl) valueEl.textContent = '—';
//         item.classList.remove('is-loading');
//         item.classList.add('is-error');
//         console.warn('[live-ticker] Could not find numeric value for:', jsonKey, data);
//       }

//       if (changeEl) {
//         var changeKey = item.getAttribute('data-change-key');
//         var rawChange = getValueByPath(data, changeKey);
//         var formattedChange = formatNumber(rawChange, 2);

//         if (formattedChange !== null) {
//           var isUp = Number(rawChange) >= 0;
//           changeEl.classList.toggle('is-up', isUp);
//           changeEl.classList.toggle('is-down', !isUp);

//           var arrow = isUp
//             ? '<svg viewBox="0 0 24 24" fill="none"><path d="M12 19V5M12 5L5 12M12 5l7 7" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>'
//             : '<svg viewBox="0 0 24 24" fill="none"><path d="M12 5v14M12 19l-7-7M12 19l7-7" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

//           changeEl.innerHTML = arrow + (isUp ? '+' : '') + formattedChange + '%';
//         } else {
//           changeEl.textContent = '';
//         }
//       }
//     });
//   }

//   function markGroup(elements, state) {
//     elements.forEach(function (item) {
//       item.classList.remove('is-loading', 'is-error');
//       item.classList.add(state);
//     });
//   }

//   /**
//    * Fetch one unique URL and apply the result to every element that
//    * shares it. Never rejects, so Promise.all always completes.
//    */
//   function fetchGroup(container, apiUrl, elements) {
//     if (!apiUrl) {
//       elements.forEach(function (item) {
//         var valueEl = item.querySelector('[data-rate-value]');
//         if (valueEl) valueEl.textContent = 'No URL set';
//       });
//       markGroup(elements, 'is-error');
//       return Promise.resolve();
//     }

//     markGroup(elements, 'is-loading');

//     var request = buildRequest(container, apiUrl);

//     return fetch(request.url, request.options)
//       .then(function (response) {
//         if (!response.ok) {
//           throw new Error('API request failed with status ' + response.status);
//         }
//         return response.json();
//       })
//       .then(function (data) {
//         applyDataToGroup(elements, data);
//       })
//       .catch(function (error) {
//         console.error('[live-ticker] Group fetch failed:', apiUrl, error);
//         elements.forEach(function (item) {
//           var valueEl = item.querySelector('[data-rate-value]');
//           if (valueEl) valueEl.textContent = 'N/A';
//         });
//         markGroup(elements, 'is-error');
//       });
//   }

//   /**
//    * Group every duplicated [data-c4h-rate-item] by its api-url, then
//    * fetch each unique URL exactly once.
//    */
//   function fetchAllItems(container) {
//     var items = container.querySelectorAll('[data-c4h-rate-item]');
//     var groups = {};

//     items.forEach(function (item) {
//       var url = item.getAttribute('data-rate-url');
//       if (!groups[url]) groups[url] = [];
//       groups[url].push(item);
//     });

//     var promises = Object.keys(groups).map(function (url) {
//       return fetchGroup(container, url, groups[url]);
//     });

//     return Promise.all(promises);
//   }

//   function startAutoRefresh(container) {
//     var refreshInterval = parseInt(container.getAttribute('data-refresh-interval') || '0', 10);
//     if (refreshInterval <= 0) return;

//     if (container._c4hRefreshTimer) {
//       clearInterval(container._c4hRefreshTimer);
//     }

//     container._c4hRefreshTimer = setInterval(function () {
//       fetchAllItems(container);
//     }, refreshInterval);
//   }

//   function initContainer(container) {
//     if (container.dataset.c4hInitialized === 'true') return;
//     container.dataset.c4hInitialized = 'true';

//     fetchAllItems(container);
//     startAutoRefresh(container);
//   }

//   function init() {
//     document.querySelectorAll('[data-c4h-live-rates]').forEach(initContainer);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

//   /**
//    * Shopify Theme Editor support: re-initialize when a section is
//    * reloaded after a settings change, without a full page refresh.
//    */
//   document.addEventListener('shopify:section:load', function (event) {
//     var section = event.target;
//     var container = section.querySelector('[data-c4h-live-rates]');
//     if (container) {
//       container.dataset.c4hInitialized = 'false';
//       initContainer(container);
//     }
//   });
// })();

/**
 * Live Price Ticker
 *
 * Built for an infinite-scroll ticker where each price item is
 * duplicated many times in the DOM (for a seamless CSS scroll loop).
 * Fetches each UNIQUE api-url only ONCE per refresh cycle, then applies
 * the result to every duplicated element sharing that URL - avoids
 * hammering the API with redundant simultaneous requests.
 *
 * Supports:
 * - Header authentication
 * - Query parameter authentication
 * - Nested JSON values
 * - 24h change indicator (up/down arrow, colored by sign)
 * - Auto refresh
 * - Per-group loading/error state
 * - Shopify Theme Editor section reloads
 */

(function () {
  'use strict';

  function getValueByPath(object, path) {
    if (!object || !path) return undefined;

    return path.split('.').reduce(function (current, key) {
      if (current !== null && current !== undefined && Object.prototype.hasOwnProperty.call(current, key)) {
        return current[key];
      }
      return undefined;
    }, object);
  }

  function formatNumber(value, decimals) {
    if (value === null || value === undefined || value === '') return null;
    var number = Number(value);
    if (!Number.isFinite(number)) return null;
    return number.toFixed(decimals);
  }

  function getApiKey(container) {
    var configElement = container.querySelector('[data-c4h-api-config]');
    if (!configElement) return '';

    try {
      var config = JSON.parse(configElement.textContent);
      return config.apiKey || '';
    } catch (error) {
      console.error('[live-ticker] Unable to read API configuration:', error);
      return '';
    }
  }

  function buildRequest(container, apiUrl) {
    var apiKey = getApiKey(container);
    var authMethod = container.getAttribute('data-auth-method') || 'header';

    var options = {
      method: 'GET',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    };

    if (apiKey && authMethod === 'query') {
      var parameterName = container.getAttribute('data-key-param-name') || 'api_key';
      var separator = apiUrl.indexOf('?') === -1 ? '?' : '&';
      apiUrl += separator + encodeURIComponent(parameterName) + '=' + encodeURIComponent(apiKey);
    }

    if (apiKey && authMethod === 'header') {
      var headerName = container.getAttribute('data-header-name') || 'Authorization';
      var headerPrefix = container.getAttribute('data-header-prefix') || '';
      options.headers[headerName] = headerPrefix + apiKey;
    }

    return { url: apiUrl, options: options };
  }

  /**
   * Apply a successful response to every duplicated copy of one item.
   */
  function applyDataToGroup(elements, data) {
    elements.forEach(function (item) {
      var valueEl = item.querySelector('[data-rate-value]');
      var changeEl = item.querySelector('[data-rate-change]');

      var jsonKey = item.getAttribute('data-rate-key');
      var decimals = parseInt(item.getAttribute('data-rate-decimals') || '2', 10);
      var prefix = item.getAttribute('data-rate-prefix') || '';
      var suffix = item.getAttribute('data-rate-suffix') || '';

      var rawValue = getValueByPath(data, jsonKey);
      var formattedValue = formatNumber(rawValue, decimals);

      if (formattedValue !== null) {
        if (valueEl) valueEl.textContent = prefix + formattedValue + suffix;
        item.classList.remove('is-loading', 'is-error');
      } else {
        if (valueEl) valueEl.textContent = '—';
        item.classList.remove('is-loading');
        item.classList.add('is-error');
        console.warn('[live-ticker] Could not find numeric value for:', jsonKey, data);
      }

      if (changeEl) {
        var changeKey = item.getAttribute('data-change-key');
        var rawChange = getValueByPath(data, changeKey);
        var formattedChange = formatNumber(rawChange, 2);

        if (formattedChange !== null) {
          var isUp = Number(rawChange) >= 0;
          changeEl.classList.toggle('is-up', isUp);
          changeEl.classList.toggle('is-down', !isUp);

          var arrow = isUp
            ? '<svg viewBox="0 0 24 24" fill="none"><path d="M12 19V5M12 5L5 12M12 5l7 7" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            : '<svg viewBox="0 0 24 24" fill="none"><path d="M12 5v14M12 19l-7-7M12 19l7-7" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

          changeEl.innerHTML = arrow + (isUp ? '+' : '') + formattedChange + '%';
        } else {
          changeEl.textContent = '';
        }
      }
    });
  }

  function markGroup(elements, state) {
    elements.forEach(function (item) {
      item.classList.remove('is-loading', 'is-error');
      item.classList.add(state);
    });
  }

  /**
   * Fetch one unique URL and apply the result to every element that
   * shares it. Never rejects, so Promise.all always completes.
   */
  function fetchGroup(container, apiUrl, elements) {
    if (!apiUrl) {
      elements.forEach(function (item) {
        var valueEl = item.querySelector('[data-rate-value]');
        if (valueEl) valueEl.textContent = 'No URL set';
      });
      markGroup(elements, 'is-error');
      return Promise.resolve();
    }

    markGroup(elements, 'is-loading');

    var request = buildRequest(container, apiUrl);

    return fetch(request.url, request.options)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('API request failed with status ' + response.status);
        }
        return response.json();
      })
      .then(function (data) {
        applyDataToGroup(elements, data);
      })
      .catch(function (error) {
        console.error('[live-ticker] Group fetch failed:', apiUrl, error);
        elements.forEach(function (item) {
          var valueEl = item.querySelector('[data-rate-value]');
          if (valueEl) valueEl.textContent = 'N/A';
        });
        markGroup(elements, 'is-error');
      });
  }

  /**
   * Group every duplicated [data-c4h-rate-item] by its api-url, then
   * fetch each unique URL exactly once.
   */
  function fetchAllItems(container) {
    var items = container.querySelectorAll('[data-c4h-rate-item]');
    var groups = {};

    items.forEach(function (item) {
      var url = item.getAttribute('data-rate-url');
      if (!groups[url]) groups[url] = [];
      groups[url].push(item);
    });

    var promises = Object.keys(groups).map(function (url) {
      return fetchGroup(container, url, groups[url]);
    });

    return Promise.all(promises);
  }

  /**
   * Auto-refresh is intentionally disabled. Both connected APIs have hit
   * their limits (402 Payment Required from the oil price provider, 429
   * Too Many Requests from the exchange rate provider) - repeatedly
   * polling makes both worse. Data now loads once per page view only.
   * To re-enable later: restore the setInterval body here and the
   * startAutoRefresh(container) call in initContainer() below.
   */
  function startAutoRefresh(container) {
    return;
  }

  function initContainer(container) {
    if (container.dataset.c4hInitialized === 'true') return;
    container.dataset.c4hInitialized = 'true';

    fetchAllItems(container);
    startAutoRefresh(container);
  }

  function init() {
    document.querySelectorAll('[data-c4h-live-rates]').forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /**
   * Shopify Theme Editor support: re-initialize when a section is
   * reloaded after a settings change, without a full page refresh.
   */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    var container = section.querySelector('[data-c4h-live-rates]');
    if (container) {
      container.dataset.c4hInitialized = 'false';
      initContainer(container);
    }
  });
})();